import React from "react";
import { Box } from "@chakra-ui/react";

const PANEL_VARIANTS = {
  outline: {
    bg: "surface.subtle",
    borderColor: "border.default",
    borderWidth: "1px",
    borderRadius: "ui-md",
  },
  solid: {
    bg: "surface.card",
    borderColor: "border.default",
    borderWidth: "1px",
    borderRadius: "ui-md",
  },
  ghost: {
    bg: "transparent",
    borderRadius: "ui-md",
  },
};

export default function UiPanel({ variant = "outline", ...props }) {
  const styleProps = PANEL_VARIANTS[variant] || PANEL_VARIANTS.outline;
  return <Box p={4} {...styleProps} {...props} />;
}
